import { automationConfig } from '../lib/config'

export interface DocumentUploadRequest {
  companyName: string
  companyId: string
  filename: string
  fileType: string
  fileContent: string
  fileSizeBytes: number
}

export interface DocumentUploadResponse {
  success: boolean
  message?: string
  chunksCreated?: number
}

export async function uploadDocument(
  request: DocumentUploadRequest
): Promise<DocumentUploadResponse> {
  const response = await fetch(`${automationConfig.n8n.baseUrl}/webhook/upload-document`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(request),
  })

  if (!response.ok) {
    throw new Error('Failed to upload document')
  }

  return response.json()
}

export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      const result = reader.result as string
      const base64 = result.split(',')[1]
      resolve(base64)
    }
    reader.onerror = (error) => reject(error)
  })
}

export function getFileExtension(filename: string): string {
  const parts = filename.split('.')
  return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : 'txt'
}

export const SUPPORTED_FILE_TYPES = [
  'pdf',
  'doc',
  'docx',
  'pptx',
  'txt',
  'csv',
  'xlsx',
  'xls',
  'md',
  'json',
] as const

export type SupportedFileType = (typeof SUPPORTED_FILE_TYPES)[number]

export function isSupportedFileType(extension: string): extension is SupportedFileType {
  return SUPPORTED_FILE_TYPES.includes(extension as SupportedFileType)
}
